import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/demo.vue";
import imgOn from "../../../assets/images/on.png"
import imgOff from "../../../assets/images/off.png"
import red from "../../../assets/images/red.png"

import iCar from "../../../components/CarTable.vue"

export default {
    name: "ElectricFence",
    components: { tree, iTable, IPagination, iCar },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            fenceName: '',
            height: '320',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                height: false,
                mutiSelect: false,
                serialNumber: false,
            },
            columns: [
                {
                    prop: "fenceName",
                    label: this.$t('SafeManagement.fenceName'),
                    align: "center",
                },
            ],
            dialogDelFormVisible: false,
            carItem: {},
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'el-icon-edit',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.editTem(row)
                        }
                    },
                    {
                        id: '2',
                        show: true,
                        icon: 'el-icon-delete',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogDelFormVisible = true
                            this.deleteTem(row)
                        }
                    }
                ],
            },
            reserve: true,
            rowKey: 'fenceNum',
            currentPage: 1,
            pageSize: 10,
            total: 1,
            mapLoading: false,
            carOptions: [],
            btnShow: true,
            carId: '',
            title: '',
            btnType: '',
            dialogFormVisible: false,
            formLabelWidth: "70px",
            form: {
                terminalId: '',
                fenceName: '',
                pointList: [],
                // centerLng: '',
                // centerLat: '',
                // radius: '',
                // level: ''
            },
            rules: {},
            btnSpin: false,
            isUpdate: false,
            drawingManager: null,
            allPoint: [],
            // centerPoints: [],
            // CircleRadiu: '',
            // levels: '',
            styleOptions: {
                // strokeColor: 'blue',
                // fillColor: '#5E87DB',
                // strokeWeight: 2,
                // strokeOpacity: 1,
                // fillOpacity: 0.2
                zIndex: 10,
                // node: node,
                // nodeT: nodeT,
                fillOpacity: 0.2,
                fillColor: '#5E87DB',
                strokeStyle: 'solid',
                strokeColor: 'blue',
                strokeWeight: 2,
                strokeOpacity: 1,
            },
            rowClickData: {},
            editMap: false,
            flag: true,
            polygonObj: null,
            id: ''
        }
    },
    created() {

    },
    mounted() {
        let that = this
        this.map = new BMapGL.Map('allmap');
        this.map.setMapStyleV2({
            styleId: ''
        });
        this.map.centerAndZoom(new BMapGL.Point(117.3, 31.8), 5);
        this.map.addControl(new BMapGL.MapTypeControl({
            mapTypes: [
                BMAP_NORMAL_MAP,
                BMAP_HYBRID_MAP
            ]
        }));
        this.map.enableScrollWheelZoom(true);

        this.drawingManager = new BMapGLLib.DrawingManager(this.map, {
            isOpen: false,
            enableCalculate: false,
            enableSorption: true,
            sorptiondistance: 20,
            polygonOptions: this.styleOptions,
        });

        this.drawingManager.addEventListener('overlaycomplete', function (e) {
            that.overlaycomplete(e)
        })
    },

    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getListElectronicFence()

        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getListElectronicFence()

        },
        getListElectronicFence() {
            let param = {
                orgId: this.id,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                fenceName: this.fenceName,
            }
            this.$store.dispatch('ElectricFence/GET_GETELECTRONICFENCE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        const allOverlays = this.map.getOverlays()
                        allOverlays.map((item) => {
                            this.map.removeOverlay(item)
                        })
                        if (res.data.data.list.length > 0) {
                            res.data.data.list.map((item, index) => {
                                if (index == 0) {
                                    this.getFenceData(item)
                                    this.getFence(item, "query");
                                }
                            });
                        } else {

                            this.getData();
                        }
                        this.$refs.page.CommandTotal = res.data.data.total

                    }
                }
            }).catch(err => { })
        },
        rowClick(row) {
            this.isUpdate = false
            this.btnShow = true
            const allOverlays = this.map.getOverlays()
            allOverlays.map((item) => {
                this.map.removeOverlay(item)
            })
            this.getFence(row, 'query')
            this.getFenceData(row)
        },
        getFence(row, type) {
            console.log(row, type)
            // this.centerPoint = [row.centerLng, row.centerLat];
            // this.CircleRadius = row.radius

            // this.level = row.level;
            // let arr = [];
            // var centerPoint = new BMapGL.Point(row.centerLng, row.centerLat);
            // arr.push(centerPoint);
            // let view = this.map.getViewport(eval(arr));
            // let centerPoints = view.center;
            // this.map.centerAndZoom(centerPoints, this.level);
            if (row.pointList) {
                try {
                    const points = JSON.parse(row.pointList);
                    this.allPoint = points.map(p => new BMapGL.Point(p.lng, p.lat));
                } catch (e) {
                    this.allPoint = [];
                }
            }
            // this.circleObj = new BMapGL.Polygon(new BMapGL.Point(this.centerPoint[0], this.centerPoint[1]), this.CircleRadius, this.styleOptions);
            this.polygonObj = new BMapGL.Polygon(this.allPoint, this.styleOptions);
            this.polygonObj.name = 'polygon'
            if (type == 'edit') {
                this.Editing('enable')
            } else if (type == 'query') {
                this.clearAll()
                this.map.addOverlay(this.polygonObj);
                if (this.allPoint.length > 0) {
                    const view = this.map.getViewport(this.allPoint)
                    this.map.centerAndZoom(view.center, view.zoom)
                }
            }
            this.polygonObj.addEventListener("lineupdate", this.lineupdate)
        },
        getData() {
            let param = {
                orgId: this.id,
            }
            this.$store.dispatch('VehicleDistribution/GET_SELECTCARLOCATIONLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.carOptions = res.data.data
                        let arr = [];
                        res.data.data.map((item) => {
                            var point = new BMapGL.Point(item.longitude, item.latitude);
                            arr.push(point);
                        });
                        let view = this.map.getViewport(eval(arr));
                        let mapZoom = view.zoom;
                        let centerPoints = view.center;
                        this.map.centerAndZoom(centerPoints, mapZoom);
                        this.initMap()
                    }
                }
            }).catch(err => { })
        },
        getFenceData(row) {
            let param = {
                fenceNum: row.fenceNum,
            }
            this.$store.dispatch('ElectricFence/GET_GETFENCETERMINAL', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.carOptions = res.data.data
                        this.initMap()
                    }
                }
            }).catch(err => { })
        },
        initMap() {
            var imgOnPic = new Image()
            imgOnPic.src = imgOn
            var imgOffPic = new Image()
            imgOffPic.src = imgOff
            this.carOptions.map((item, index) => {
                if (item.linkState == 0) {
                    var icon = new BMapGL.Icon(imgOffPic, new BMapGL.Size(35, 32), {
                        anchor: new BMapGL.Size(10, 30)
                    });
                    var points = new BMapGL.Point(item.longitude, item.latitude);
                }
                else if (item.linkState == 1) {
                    var icon = new BMapGL.Icon(imgOnPic, new BMapGL.Size(35, 32), {
                        anchor: new BMapGL.Size(10, 30)
                    });
                    var points = new BMapGL.Point(item.longitude, item.latitude);

                }
                var markers = new BMapGL.Marker(points, { icon: icon });
                this.map.addOverlay(markers);
            })


        },
        draw() {
            const drawingType = BMAP_DRAWING_POLYGON
            if (this.drawingManager._isOpen && this.drawingManager.getDrawingMode() === drawingType) {
                this.drawingManager.close();
            } else {
                this.drawingManager.setDrawingMode(drawingType);
                this.drawingManager.open();
            }
        },
        overlaycomplete(e) {
            console.log(e)
            if (e.drawingMode === "polygon") {
                // this.CircleRadius = e.overlay.getRadius();
                // this.centerPoint = e.overlay.getCenter();
                // this.level = e.overlay.map.getZoom();
                this.allPoint = e.overlay.getPath();
            }
        },
        Editing(state) {
            const allOverlays = this.map.getOverlays().filter(father => {
                return father.name === 'polygon'
            })
            allOverlays.map(item => {
                console.log(item)
                state == 'enable' ? item.enableEditing() : item.disableEditing()
            })
        },


        lineupdate(e) {
            console.log(e)
            var p = e.target;
            this.isUpdate = true
            this.flag = true;
            this.allPoint = p.getPath();
            // this.CircleRadiu = p.getRadius();
            // this.centerPoints = p.getCenter();
            // this.allPoint = p.points
            // this.levels = p.map.getZoom();
            p.addEventListener("onmouseout", function (e1) {
                let pd = e1.target;
                if (this.polygonObj.getRadius() == pd.getRadius()) {
                    if (flag) {
                        this.allPoint = p.getPath();
                        // this.CircleRadiu = p.getRadius()
                        // this.centerPoints = p.getCenter()
                        // this.levels = p.map.getZoom();
                    }
                    this.flag = false;
                }
            })
        },
        onkeyUp() {
            this.pageNum = 1
            this.getListElectronicFence()
        },
        changeSize() {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getListElectronicFence();
        },

        createMap() {
            this.btnType = 'add'
            this.btnShow = false;
            this.editMap = true;
            this.allPoint = [];
            // this.centerPoint = []
            // this.CircleRadius = null
            // this.level = null;
            this.clearAll()
            this.draw()
            this.getData();
        },
        editTem(row) {
            this.btnShow = false;
            this.editMap = true;
            this.btnType = 'edit'
            this.isUpdate = false
            this.carItem = row
            if (row.pointList) {
                try {
                    const pointsArray = JSON.parse(row.pointList)
                    this.allPoint = pointsArray.map(p => new BMapGL.Point(p.lng, p.lat))
                } catch (e) {
                    this.allPoint = []
                }
            }
            this.getFence(row, 'edit')
            // this.carItem = row
        },

        PutData() {
            this.dialogFormVisible = true
            this.editMap = false
            if (this.btnType == 'add') {
                this.title = this.$t('ElectricFence.createFence')
                this.form.fenceName = ''
                this.form.pointList = this.getFormatPoints(this.allPoint)
                // this.form.radius = this.CircleRadius
                // this.form.centerLng = this.centerPoint.lng
                // this.form.centerLat = this.centerPoint.lat
                // this.form.level = this.level
            } else {
                console.log('=====>', this.carItem, this.carList, this.carFenceList)
                this.title = this.$t('ElectricFence.editFence')
                this.form.fenceName = this.carItem.fenceName
                if (this.isUpdate) {
                    this.form.pointList = this.getFormatPoints(this.allPoint)
                    // this.form.radius = this.CircleRadiu
                    // this.form.centerLng = this.centerPoints.lng
                    // this.form.centerLat = this.centerPoints.lat
                    // this.form.level = this.levels
                } else {
                    // this.form.radius = this.carItem.radius
                    // this.form.centerLng = this.carItem.centerLng
                    // this.form.centerLat = this.carItem.centerLat
                    // this.form.level = this.carItem.level
                    this.form.pointList = this.carItem.pointList
                    if (this.carItem.pointList) {
                        try {
                            const pointsArray = JSON.parse(this.carItem.pointList)
                            this.allPoint = pointsArray.map(p => new BMapGL.Point(p.lng, p.lat))
                        } catch (e) {
                            this.allPoint = []
                        }
                    }
                }
                this.$nextTick(() => {
                    this.$refs.transfer.getRightTerminal()
                })
            }


        },
        postParam(data) {
            if (data.length > 0) {
                let terminalIds = "";
                data.map((item, index) => {
                    if (index == 0) {
                        terminalIds = item.terminalId;
                    } else {
                        terminalIds = terminalIds + "," + item.terminalId;
                    }
                    this.form.terminalId = terminalIds;
                });
            } else {
                this.form.terminalId = "";
            }
        },
        getFormatPoints(points) {
            if (!points || points.length === 0) return '';
            const formatData = points.map(p => ({
                lng: p.lng,
                lat: p.lat
            }));
            return JSON.stringify(formatData);
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const pointListStr = this.getFormatPoints(this.allPoint);
                    let param = {
                        orgId: this.id,
                        terminalId: this.form.terminalId,
                        fenceName: this.form.fenceName,
                        pointList: pointListStr,
                        // centerLng: this.form.centerLng,
                        // centerLat: this.form.centerLat,
                        // radius: this.form.radius,
                        // level: this.form.level
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('ElectricFence/GET_INSERTELECTRONICFENCE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('SafeManagement.form.addFenceSuccess'))
                                // this.centerPoint = []
                                // this.CircleRadius = null
                                this.allPoint = [];
                                this.btnShow = true
                                this.editMap = false
                                this.getListElectronicFence()
                                this.dialogFormVisible = false
                            } else {
                                this.dialogFormVisible = true
                                this.$message.error(res.data.msg)
                            }
                        }).catch(err => {

                        })
                    } else {
                        param.fenceNum = this.carItem.fenceNum
                        this.$store.dispatch('ElectricFence/GET_UPDATEELECTRONICFENCE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('SafeManagement.editFenceSuccess'))
                                // this.centerPoint = []
                                // this.CircleRadius = null
                                this.allPoint = [];
                                this.btnShow = true
                                this.editMap = false
                                this.getListElectronicFence()
                                this.dialogFormVisible = false

                            } else {
                                this.dialogFormVisible = true
                                this.$message.error(res.data.msg)
                            }
                        }).catch(err => {

                        })
                    }

                }
                else {

                    return false;
                }
            });
        },

        resetForm(formName) {
            this.dialogFormVisible = false
            this.$refs.form.resetFields();
        },
        cancle() {
            // this.centerPoint = []
            // this.CircleRadius = null
            // this.level = ''
            this.allPoint = []
            this.clearAll()
            this.initMap()
            this.btnShow = true
        },
        deleteTem(row) {
            console.log(row)
            let param = {
                fenceNum: row.fenceNum,
            }
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                confirmButtonText: this.$t('common.btn.confirm'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('ElectricFence/GET_DELETEELECTRONICFENCE', param).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                        this.getListElectronicFence('query')
                        this.clearAll()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                }).catch(err => { })
            }).catch(() => { });
        },
        clearAll() {
            const allOverlays = this.map.getOverlays()
            allOverlays.map((item) => {
                if (item.name == 'polygon') {
                    this.map.removeOverlay(item)
                }
            })
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}